
import './Home.css';
const Home = () => {
    return (
        <div className="container"></div>
      );
}
 
export default Home;